import {
  SET_USER_LOCATION,
  SET_DELIVERY_TYPE,
  SET_ORDER_DELIVERY_TYPE,
  SET_ORDER_POSTCODE,
  SET_RESTAURANT,
  ADD_TO_CART,
  REMOVE_FROM_CART,
  INCREASE_ITEM_QUANTITY,
  DECREASE_ITEM_QUANTITY,
  UPDATE_CART_PRODUCT,
  CLEAR_CART
} from './mutation-types'

export const setUserLocation = ({ commit }, location) => {
  commit(SET_USER_LOCATION, location)
}

export const setDeliveryType = ({ commit }, type) => {
  commit(SET_DELIVERY_TYPE, type)
}

export const setOrderDeliveryType = ({ commit }, type) => {
  commit(SET_ORDER_DELIVERY_TYPE, type)
}

export const setOrderPostcode = ({ commit }, postcode) => {
  commit(SET_ORDER_POSTCODE, postcode)
}

export const setCartRestaurant = ({ commit }, restaurant) => {
  commit(SET_RESTAURANT, restaurant)
}

export function addItemToCart ({ commit, state }, cartItem) {
  if (state.items.filter(item => item.product.id === cartItem.product.id).length > 0) {
    [...Array(cartItem.quantity)].forEach(_ => commit(INCREASE_ITEM_QUANTITY, cartItem))
  } else {
    commit(ADD_TO_CART, cartItem)
  }
}
export function removeItemFromCart ({ commit }, cartItemProductId) {
  commit(REMOVE_FROM_CART, cartItemProductId)
}

export function increaseItemQuantity ({ commit }, cartItem) {
  commit(INCREASE_ITEM_QUANTITY, cartItem)
}

export function decreaseItemQuantity ({ commit }, cartItem) {
  commit(DECREASE_ITEM_QUANTITY, cartItem)
}

export function updateCartProduct ({ commit }, payload) {
  commit(UPDATE_CART_PRODUCT, payload)
}

export function clearCart ({ commit }) {
  commit(CLEAR_CART)
}



// WEBPACK FOOTER //
// ./src/vuex/modules/cart/actions.js